export const formatRiskVesselLengthDisplay = (
  vesselLengthInMeters: number,
): string => {
  const vesselLengthInFeet = vesselLengthInMeters * 3.28084;
  return `${vesselLengthInMeters.toFixed(1)}m (${vesselLengthInFeet.toFixed(1)}ft)`;
};
